export const AUTHENTICATION_CONFIGURATION_NAMES = {
  CSOD: 'CsodSaml',
  OKTA: 'Okta',
  ENTRA: 'Entra',
} as const satisfies Record<string, string>;

export type AuthenticationConfigNameType =
  (typeof AUTHENTICATION_CONFIGURATION_NAMES)[keyof typeof AUTHENTICATION_CONFIGURATION_NAMES];
